import { Accordion } from 'components';
import { useTranslation } from 'react-i18next';
import { STextField } from './styled';
import { Box as MuiBox } from '@mui/material';
import { FormControl, JamIcon } from 'components/ui';

export default function CpfAccordion({ isRequired = true }) {
  const { t } = useTranslation();

  return (
    <Accordion
      title={t('CPF') + (isRequired ? ' *' : '')}
      startAdornment={<JamIcon icon="id-card" />}
    >
      <MuiBox style={{ display: 'flex', gap: 30 }}>
        <FormControl label={t('CPF')}>
          <STextField dataId="cpf-input" name="cpf" placeholder={t('CPF')} />
        </FormControl>
      </MuiBox>
    </Accordion>
  );
}
